import { networkColorKeyFor, networkIconFor } from '@alison/ui';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface NetworkGlyphProps {
  network: string | null;
}

export function NetworkGlyph({ network }: NetworkGlyphProps): ReactNode {
  const theme = useTheme();
  const NetworkIcon = networkIconFor(network);
  const colorKey = networkColorKeyFor(network);
  const fallbackColor = colorKey ? theme.palette.network[colorKey] : theme.palette.text.secondary;

  return (
    <Tooltip title={network ?? 'Unknown network'} placement="top">
      {NetworkIcon ? (
        <NetworkIcon sx={{ fontSize: 18, flexShrink: 0 }} />
      ) : (
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            width: 18,
            height: 18,
            borderRadius: 0.5,
            bgcolor: fallbackColor,
            color: 'common.white',
            flexShrink: 0,
          }}
        >
          <Typography variant="overline" sx={{ color: 'inherit' }}>
            {(network ?? '?').charAt(0).toUpperCase()}
          </Typography>
        </Box>
      )}
    </Tooltip>
  );
}
